import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { noneZeroValidator, validDateValidator } from '../shared/validators';

@Injectable({ providedIn: 'root' })
export class WithdrawFundsFormProvider {
  investmentForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  initWithdrawFundsForm(data?: any): FormGroup {
    return (this.investmentForm = this.fb.group({
      investorId: [data?.investorId, [Validators.required]],
      intermediaryName: [''],
      intermediaryId: [data?.intermediaryId],
      type: [data?.type || '', [Validators.required]],
      transactionType: ['Redemption'],
      date: [data?.date || moment().format('YYYY-MM-DD'), [Validators.required, validDateValidator()]],
      faceValue: [+data?.faceValue || '', [Validators.required, noneZeroValidator(), Validators.pattern('^[0-9,.]*$')]],
      product: ['ETR', [Validators.required]],
      ccy: [data?.ccy || ''],
      comments: [data?.comments],
    }));
  }
}
